import { Map, Set, OrderedSet, OrderedMap } from 'immutable';

import * as types from './types';
import { MetricsRecord, TestCaseRecord } from './../../records';
import { TOTAL_RUNS } from './../../constants';
import { testCasesSort } from './../../util';
import { clearSelectedVersion } from '../test-summary/reducers';

const initialState = new Map({
  trends: new OrderedMap({
    status: new Set(),
    browser: new Set(),
    browserError: new Set(),
    browserFail: new Set(),
    os: new Set(),
    osError: new Set(),
    osFail: new Set(),
    statusRecord: new OrderedMap({
      totalRuns: new MetricsRecord({
        title: TOTAL_RUNS,
        labelClassName: 'blue',
      }),
      passed: new MetricsRecord({
        title: 'Test Passed',
        labelClassName: 'success',
      }),
      errored: new MetricsRecord({
        title: 'Test Error',
        labelClassName: 'warning',
      }),
      failed: new MetricsRecord({
        title: 'Test Failed',
        labelClassName: 'danger',
      }),
      complete: new MetricsRecord({
        title: 'Test Completed',
      }),
    }),
  }),
  testNames: new OrderedSet(),
  testNamesCount: 0,
  testCaseQuery: '',
  fadeMetrics: true,
  loadingData: true,
});

const testOverviewReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_TEST_TRENDS.REQUEST:
      return state.set('fadeMetrics', false).set('loadingData', true);
    case types.GET_TEST_TRENDS.SUCCESS:
      return state.withMutations((newState) => {
        clearSelectedVersion(newState);

        Object.entries(payload.metrics).map(([key, metrics]) => newState.setIn(
          ['trends', key],
          new Set(
            Object
              .entries(metrics)
              .map(([title, value]) => ({ title, value })),
          ),
        ));

        let totalTests = 0;
        Object.entries(payload.metrics.status)
          .forEach(([key, value]) => {
            totalTests += value;
            newState.setIn(['trends', 'statusRecord', key, 'value'], value);
          });
        newState.setIn(['trends', 'statusRecord', 'totalRuns', 'value'], totalTests);
        newState.set('fadeMetrics', true).set('loadingData', false);
      });
    case types.GET_AGGREGATED_TEST_ERRORS.REQUEST:
      return state;
    case types.GET_PAST_TRENDS.SUCCESS:
      return state.withMutations((newState) => {
        let totalTests = 0;
        Object.entries(payload.metrics.status)
          .forEach(([key, value]) => {
            totalTests += value;
            newState.setIn(['trends', 'statusRecord', key, 'previousValue'], value);
          });
        newState.setIn(['trends', 'statusRecord', 'totalRuns', 'previousValue'], totalTests);
      });
    case types.GET_AGGREGATED_TEST_NAMES.REQUEST:
      return state.set('loadingData', true);
    case types.GET_AGGREGATED_TEST_NAMES.SUCCESS:
      return state.withMutations((newState) => {
        const items = payload.items.map((testCase) => new TestCaseRecord({
          ...testCase,
        }));
        newState.set('testNames', new OrderedSet(items));
        newState.set('loadingData', false);
        newState.set('testNamesCount', payload.all_items_count);
      });
    case types.SORT_TEST_CASES:
      return state.withMutations((newState) => {
        const sortedTestCases = testCasesSort(state.get('testNames'), payload.sortFieldName, payload.sortDescending);
        newState.set('testNames', sortedTestCases);
      });
    case types.SET_TEST_CASE_QUERY:
      return state.set('testCaseQuery', payload);
    default:
      return state;
  }
};

export default testOverviewReducer;
export { initialState };
